import axios from 'axios'
import { LocalStorageService } from '../services'


class TemplateService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    url = process.env.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()

    async getTemplatebyClientId(clientId, companyId, token) {
        const url = new URL(`${this.apiUrl}/templates`);
        if (clientId && clientId !== "") url.searchParams.append('clientId', clientId);
        if (companyId && companyId !== "") url.searchParams.append('companyId', companyId);

        let response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data.data
    }

    async getVariablesFromDocument(doc, token) {
        let response = await axios.post(`${this.apiUrl}/doc-reading`, doc, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }

    async createNewTemplate(data, token) {
        let response = await axios.post(`${this.apiUrl}/template`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }

    async createTemplate(clientId, companyId, name, description, token) {
        let response = await axios.post(`${this.apiUrl}/template`, {
            clientId,
            companyId,
            name,
            description
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data.data
    }

    async getCompanies(token) {
        let response = await axios.get(`${this.apiUrl}/client-company`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data.data
    }

    async getFormatVariables(token) {
        let response = await axios.get(`${this.apiUrl}/format-variables`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data.data
    }

    async updateTemplate(data, token) {
        let response = await axios.put(`${this.apiUrl}/template`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }

    async deleteTemplate(id, token) {
        let response = await axios.delete(`${this.apiUrl}/template?id=${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })

        return response.data
    }

    async getTemplatebyDocumentPath(documentPath, token) {
        let response = await axios.post(`${this.apiUrl}/template-pdf`, {
            documentPath
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data.data
    }

    async getTEmplateFile(id, token){
        let response = await axios.get(`${this.apiUrl}/template-file?id=${id}`,{
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }

    async syncFusionUpdateTemplate(templateId, updatedPathname, token, modificationConfirmed) {
        let response = await axios.put(`${this.apiUrl}/update-template-sync`, 
        {
            templateId, updatedPathname, modificationConfirmed
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    }
}

export { TemplateService as default }
